import { defineStore } from 'pinia'
import * as bookingApi from '@/network/api/booking.api.js'
import * as managerApi from '@/network/api/customers/manager.api.js'
import i18n from '@/assets/setups/i18n'

export const useMyAccountManagerNewSchedulingStore = defineStore('myAccountManagerNewSchedulingStore', {
    state: () => ({
        accountManagerAvailableCalendar: [],
        maximumNumberOfMonthsForCalendar: 1,
        customerManagerInfo: []
    }),
    getters: {
        getAccountManagerAvailableCalendar: (state) => state.accountManagerAvailableCalendar,
        getMaximumNumberOfMonthsForCalendar: (state) => state.maximumNumberOfMonthsForCalendar,
        getCustomerManagerInfo: (state) => state.customerManagerInfo
    },
    actions: {
        async requestAccountManagerAvailableCalendar(payload) {
            const res = await bookingApi.getAccountManagerAvailableCalendar()
            if (res) {
                const data = res?.data?.data

                if (payload === 'validatingBeforeRouteChange' && !data.canCreateNewScheduling) {
                    const createErrorObj = {
                        errorLevel: 'warning',
                        response: {
                            data: {
                                code: 'max_bookings_reached',
                                dismissToastBtnText: i18n.global.t('commonButtons.gotIt'),
                                message: i18n.global.t('myAccountManager.maxBookingsReached')
                            }
                        }
                    }
                    return Promise.reject(createErrorObj)
                } else {
                    this.maximumNumberOfMonthsForCalendar = data.maximumNumberOfMonthsForCalendar
                    this.accountManagerAvailableCalendar = data.availabilities.map(day => {
                        if (!payload) return day

                        const dayToCompare = new Date(day.day)
                        const startDate = new Date(payload.startDate)

                        if (dayToCompare.getFullYear() === startDate.getFullYear() &&
                            dayToCompare.getMonth() === startDate.getMonth() &&
                            dayToCompare.getDate() === startDate.getDate()) {
                            const editTime = {
                                status: 'available',
                                startDateTime: payload.startDate,
                                endDateTime: payload.endDate
                            }

                            let times = day.dayAvailabilities
                            times.push(editTime)

                            times = times.sort((a, b) => {
                                return new Date(a.startDateTime) - new Date(b.startDateTime)
                            })

                            return {
                                ...day,
                                dayAvailabilities: times
                            }
                        }

                        return day
                    })
                }
            }
            return res
        },
        async requestCustomerManagerInfo(payload) {
            const res = await managerApi.getCustomerManagerInfo(payload)
            if (res) {
                const data = res.data.data
                this.customerManagerInfo = data
            }
            return res
        },
        async createScheduleWithAccountManager(payload) {
            const res = await bookingApi.createScheduleWithAccountManager(payload)
            return res
        },
        async editScheduleWithAccountManager(payload) {
            const res = await bookingApi.editScheduleWithAccountManager(payload)
            return res
        },
        clearFeatureStates() {
            this.accountManagerAvailableCalendar = []
            this.customerManagerInfo = []
        }
    }
})
